import * as React from 'react';
import {ContainerText} from './styles';

interface TextProps {
    children: React.ReactNode;
    fontColor?: string;
    fontSize?: string;
    fontWeight?: string;
    lineHeight? :string;
    textAlign?: string;
}

const Text:React.FC<TextProps> = ({children, fontColor, fontSize, fontWeight, lineHeight, textAlign}) => {
  return (
    <ContainerText
      fontColor={fontColor}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      textAlign={textAlign}>
      {children}
    </ContainerText>
  )
}

export default Text;
